var keyMirror = require('keymirror');

module.exports = {
    endPoints: {
        CHECK_GUEST_IN: 'api/v2/guest/checkin_guest',
        CHECK_GUEST_INTO_POS: 'api/v2/guest/checkin_guest_to_pos',
        CANCEL_TRANSACTION: 'api/v2/guest/cancel_checkin',

        SEARCH_BY_NAME: 'api/v2/guest/checkin_search_by_string',

        // LOAD_GUEST_LIST         : 'api/v2/guest/checkedin_guest_list',
        LOAD_GUEST_LIST: 'api/v2/guest/checked-in',

        GUEST_TO_REGISTER: 'api/v2/guest/Select_Guest_To_Register',
        REMOVE_GUEST_FROM_REG: 'api/v2/guest/Remove_Guest_From_Register',

        GUEST_TO_ROOM: 'api/v2/guest/Select_Guest_To_Room',

        BIOTRACK_VALIDATE_USER: 'api/posv3/Biotrack/ValidatePatient',
        BIOTRACK_SCAN_GUEST_IN: 'api/posv3/Biotrack/MDScanPatientIn',

        VALIDATE_PATIENT_ID: 'api/v2/guest/validate-id',

        SCAN: 'api/v2/guest/scan',

        GET_REGISTER_TRANSACTIONS: 'api/posv3/backendpos/get-register-transactions',
        SET_REGISTER_TRANSACTION: 'api/posv3/backendpos/UpdateRegisterTransaction',
        GET_CLOSEOUT_DETAILS: 'api/posv3/backendpos/CurrentCloseoutDetails',
        REGISTER_CLOSE_OUT: 'api/posv3/backendpos/CloseOutPost',

        GET_STATUS_LIST: 'api/posv3/maintenance/get-pos-statuses',
        GET_DEFAULT_STATUS: 'api/posv3/maintenance/get-default-pos-status',
        GET_CANCELLATION_REASONS: 'api/posv3/maintenance/get-cancellation-reasons',

        GET_COLLECTORS: 'api/MN/get-collectors',
        SELECT_COLLECTOR: 'api/MN/select-collector',
        EDIT_COLLECTOR: 'api/MN/edit-collector',

        JOIN_GUEST_NOTIFICATION_GROUP: 'api/poshub/join-group',
        AUTH_PUSHER_CHANNEL         :  'api/pusher/auth',
        GET_PUSHER_CONFIG           :  'api/pusher/config',
        GET_SIGNALR_CONNECTION: 'api/poshub/connect',
    },

    actions: keyMirror({
        GUEST_CHECKED_OUT: null,
        GUEST_LIST_LOADED: null,
        STATUS_LIST_LOADED: null,
        SEARCH_RESULTS: null,
        TOGGLE_SEARCH_BAR: null,
        TOGGLE_GUEST_ASSIGNED_TO_REGISTER: null,
        GUEST_NOTIFICATION_GROUP_JOINED: null,
        NOTIFY_CONNECTION_LOST: null,
        SIGNALR_CONNECTION_DETAILS_RETRIEVED: null,
    }),

    events: keyMirror({
        CHANGE_EVENT: 'changeEvent',
        CHECKIN_EVENT: 'changeEvent',
        SEARCH_EVENT: 'changeEvent',
        PAGE_CHANGE: 'pageChange',
    }),
};



// WEBPACK FOOTER //
// ./ui_src/app/constants/GuestListConstants.jsx